import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertToolbarComponent } from '../alert-toolbar/alert-toolbar.component';
import { AuthService } from '../auth/auth.service';
import { NonWholesaleGuardService } from '../auth/non-wholesale-guard.service';
import { CartDetailsComponent } from '../cart-details/cart-details.component';
import { CmsToolbarComponent } from '../cms-toolbar/cms-toolbar.component';
import { BraintreeFormComponent } from '../cms/braintree-form/braintree-form.component';
import { ContactComponent } from '../contact/contact.component';
import { FooterComponent } from '../footer/footer.component';
import { LoginComponent } from '../login/login.component';
import { OrderReceiptComponent } from '../order-receipt/order-receipt.component';
import { PresaveComponent } from '../presave/presave.component';
import { ProductListItemComponent } from '../product-list-item/product-list-item.component';
import { AddressComponent } from '../profile/address/address.component';
import { CustomerAddressComponent } from '../profile/customer-address/customer-address.component';
import { EmailAuthComponent } from '../profile/email-auth/email-auth.component';
import { EmailAuthShopifyComponent } from '../profile/email-auth-shopify/email-auth-shopify.component';
import { LoyaltyComponent } from '../profile/loyalty/loyalty.component';
import { OrderComponent } from '../profile/order/order.component';
import { OrderShopifyComponent } from '../profile/order-shopify/order-shopify.component';
import { SafeHtmlPipe } from '../safe-html.pipe';
import { ProductListGroupComponent } from '../store/product-list-group/product-list-group.component';
import { TopToolbarComponent } from '../top-toolbar/top-toolbar.component';
import { CartItemComponent } from './cart-item/cart-item.component';
import { CouponComponent } from './coupon/coupon.component';
import { CreditsComponent } from './credits/credits.component';
import { CustomerAddressFormComponent } from './customer-address-form/customer-address-form.component';
import { DownloadRowComponent } from './download-row/download-row.component';
import { EmailSignupComponent } from './email-signup/email-signup.component';
import { ExtraDataComponent } from './extra-data/extra-data.component';
import { LightboxImagesComponent } from './lightbox-images/lightbox-images.component';
import { NotifyEmailComponent } from './notify-email/notify-email.component';
import { PaymentMethodsComponent } from './payment-methods/payment-methods.component';
import { RegisterComponent } from './register/register.component';
import { StoreSearchComponent } from './store-search/store-search.component';
import { StoreToolbarComponent } from './store-toolbar/store-toolbar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatToolbarModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatIconModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatButtonModule,
    MatBadgeModule,
  ],
  declarations: [
    AddressComponent,
    AlertToolbarComponent,
    BraintreeFormComponent,
    CartDetailsComponent,
    CartItemComponent,
    CmsToolbarComponent,
    ContactComponent,
    CouponComponent,
    CreditsComponent,
    CustomerAddressComponent,
    CustomerAddressFormComponent,
    DownloadRowComponent,
    EmailAuthComponent,
    EmailAuthShopifyComponent,
    EmailSignupComponent,
    ExtraDataComponent,
    FooterComponent,
    LightboxImagesComponent,
    LoginComponent,
    LoyaltyComponent,
    NotifyEmailComponent,
    OrderComponent,
    OrderShopifyComponent,
    OrderReceiptComponent,
    PaymentMethodsComponent,
    PresaveComponent,
    ProductListGroupComponent,
    ProductListItemComponent,
    RegisterComponent,
    SafeHtmlPipe,
    StoreSearchComponent,
    StoreToolbarComponent,
    TopToolbarComponent,
  ],
  exports: [
    AddressComponent,
    AlertToolbarComponent,
    BraintreeFormComponent,
    CartDetailsComponent,
    CmsToolbarComponent,
    ContactComponent,
    CouponComponent,
    CreditsComponent,
    CustomerAddressComponent,
    CustomerAddressFormComponent,
    DownloadRowComponent,
    EmailAuthComponent,
    EmailAuthShopifyComponent,
    EmailSignupComponent,
    ExtraDataComponent,
    FooterComponent,
    LightboxImagesComponent,
    LoginComponent,
    LoyaltyComponent,
    NotifyEmailComponent,
    OrderComponent,
    OrderShopifyComponent,
    OrderReceiptComponent,
    PaymentMethodsComponent,
    PresaveComponent,
    ProductListGroupComponent,
    ProductListItemComponent,
    RegisterComponent,
    SafeHtmlPipe,
    StoreSearchComponent,
    StoreToolbarComponent,
    TopToolbarComponent,
  ],
  providers: [
    DatePipe,
    NonWholesaleGuardService,
    AuthService,
    JwtHelperService
  ]
})
export class SharedModule { }
